module.exports = __webpack_public_path__ + "img/arrow_top.2d4450ca.svg";